<script>
    import TabItem from './TabItem.svelte';
    import { createEventDispatcher, onMount } from 'svelte';
    import { DropDown } from '@repo/ui';
    /**
     * @typedef {Object} Props
     * @property {any} [items]
     * @property {any} [selected]
     * @property {any} [ariaLabel]
     * @property {boolean} [searchable] - Adds a filter box to the overflow dropdown.
     */
    let { items = [], selected = $bindable(null), ariaLabel = null, searchable = false } = $props();

    const dispatch = createEventDispatcher();
    let bar = $state(null);
    let collapse = $state(false);
    
    let options = $state([]);

    onMount(() => {
        options = [];
        items.forEach((i) => {
            options.push({
                displayName: i.title,
                name: i.id || i.sectionID,
                action: i.action,
            });
        });
    });

    function handleTabSelected(e) {
        document
            .querySelectorAll('.tabs .tab-item')
            .forEach((n) => n.classList.remove('selected'));
        e.detail.classList.add('selected');
        dispatch('selected', e.detail);
        selected = e.detail.dataset.sectionid;
    }

    function handleDropDownChange(e) {
        document
            .querySelector(
                `.tabs .tab-item[data-sectionid="${e.detail.value}"]`
            )
            .click();
    }

    function handleWindowResize() {
        collapse = bar.scrollWidth >= bar.getBoundingClientRect().width + 10; // 10 is for a small buffer
    }

    $effect(() => {
        handleWindowResize();
    });
</script>

<svelte:window onresize={handleWindowResize} />

<div class="tabs">
    <ul bind:this={bar} class="bar {collapse ? 'hide' : ''}">
        {#each items as item}
            <TabItem
                on:selected={handleTabSelected}
                title={item.title ? item.title : ''}
                icon={item.icon}
                description={item.description}
                sectionID={item.id || item.sectionID}
                selected={(item.id || item.sectionID) === selected}
                onlyItem={items.length === 1}
            />
        {/each}
    </ul>
    {#if collapse}
        <div class="drop-down">
            <DropDown
                onchange={handleDropDownChange}
                {options}
                color="black"
                backgroundColor="transparent"
                value={selected}
                bold={true}
                {ariaLabel}
                {searchable}
            />
        </div>
    {/if}
</div>

<style>
    .tabs {
        position: relative;
        display: flex;
        flex-direction: row;
        box-sizing: border-box;
        padding-left: 1rem;
        color: black;
        /* Redesign styling from commit 1273e509 (fix: minor style changes) commented
           out to restore the previous look without losing the change. */
        /* background-color: black; */
    }

    .tabs::-webkit-scrollbar {
        display: none;
    }

    .bar {
        position: relative;
        display: flex;
        flex-direction: row;
        box-sizing: border-box;
        width: 100%;
        overflow: hidden;
    }

    .bar.hide {
        position: absolute;
        left: -10000px;
    }

    .drop-down {
        display: flex;
        align-items: center;
        padding: 0.1rem 0.1rem;
        margin: 0.5rem 1px 0;
        background-color: rgba(255, 206, 44, 1);
        border-radius: 0.5rem 0.5rem 0 0;
    }
</style>
